import moment from "moment";
import { GetItemFromStorage } from "../../../../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../../../../custom_hooks/localStorageKeys";
import { isJSON } from "../../../../../../../base/utils";
import _ from "lodash";

export const missedCallReportColumns: any = ["Date & Time", "Queue Name", "Agent Name", "Customer Number", "Customer Name", "Queue Waiting time"];
export const answeredCallReportColumn = ["Date", "Queue Name", "Agent Name", "Received Calls", "Answered Calls", "Answered Calls %", "Total Talk Time", "Average Talk Time", "Total ACW time",
  "Average ACW", "AHT", "Average Hold", "Transferred", "Transfer %", "Occupancy rate"];

export const inboundCallReportColumn = ["Date", "Customer Number", "Customer Name", "Queue Name", "Agent Name", "Call duration", "Disposition", "Disposition Subject", "Disposition Summary", "ACW"]

//interactionReportColumn No data
export const interactionReportColumn = [
  "Date & Time", "Queue Name", "Agent Name", "Customer Number", "Customer Name", "Direction", "Total Duration", "Queue Waiting time", "Disposition", "ACW time"];
export const outBoundReportColumn = ["Date", "Customer Number", "Customer Name", "Queue Name", "Agent Name", "Call duration", "Disposition", "Disposition Subject", "Disposition Summary", "ACW"]
export const getCallBacksummaryreport = ["Date & Time", "Call Distributor", "Customer Name", "Voicemail", "Voicemail Duration", "Callback Status", "Request Date and time", "Agent Name", "Queue Name", "Queue Waiting time", "Callback Date and time", "Callback phone Number", "Callback Queue phone Number", "Callback duration"]
export const transfercallReportColumn = ["Date & Time", "Start Time", "End Time", "Customer Number", "Customer Name", "Primary Queue", "Primary Agent", "Primary Agent Handling Time", "Last Transferred Agent", "Last Agent Handling Time", "No of Handling Attempts", "Total handling time", "Total Call Duration", "Total Hold Time", "Total Wrap up Time"];
export const callcostReportColumn = ["Date", "Customer Number", "Customer Name", "Queue Name", "Agent Name", "Contact Center Number", "Country", "Call Type", "Direction", "Total Duration", "Rate Per Minute", "Total Call cost"]
//webchat
export const chatsreportColumn = ["Date & Time", "Agent Name", "Customer Name", "Queue Name", "Chat Start Time", "Chat End Time", "Duration", "Source", "Active Chat time", "Response time", "Disposition","Disposition Subject","Disposition Summary", "Queue Waiting time", "ACW time", "CSAT score"]
export const agentChatReportColumn = ["Date", "Agent Name", "Queue Name", "Total Received", "Total Handled", "Total Transferred chat", "Total Missed chat", "Total Active Chat time", "Average Active Chat time", "Average Response time"]
export const agentACWchatreportColumn = ["Date", "Agent Name", "Queue Name", "Total Interaction", "Total Active Chat time", "Average Active Chat time", "Total ACW", "Average ACW"]

//Agent

export const agentCallSummaryReport = ["Agent Name", "Routing Profile", "Inbound calls", "Inbound Time", "Outbound calls", "Outbound time", "Transferred calls", "Total call handling time", "Average Call handling time", "Total Talk time", "Average talk time", "Total ACW Time", "Average ACW", "Total hold time", "Average hold time"]
export const agentPerformancereport = ["Agent Name", "Average speed of answer", "Service Level", "Occupancy rate", "Resolved queries", "CSAT score"]
export const queryHandlingtime = ["Agent Name", "Inbounds", "Outbounds", "Total handling time", "Average handling time", "Total ACW Time", "Average ACW time", "Average Speed of answer"]
export const loginandLogoutreport = ["Date", "Agent Name", "Login Date / Time", "Logout Date / Time", "Logged-In Duration", "Available Time", "Unavailable time", "Custom Time"]
export const agentStatusreport = ["Date", "Agent Name", "Total Logged-in Time", "Ready", "Ready %", "Not Ready", "Not Ready %", "Away", "Away %", "Transfer Only", "Transfer Only % ", "Busy Time ", "Busy Time % ", "Custom State", "Custom State %"]
export const feedbackReport = ["Date & Time", "Channel", "Customer Name", "Agent Name", "CSAT Question", "CSAT score"]
//sms
export const smsreportColumn = ["Date & Time", "Customer Name", "Customer Number", "Agent Name", "Received On", "Assigned On", "Replied On", "Transferred On", "Disposition"]
export const agentsmsreportColumn = ["SessionDate", "Agent Name", "Total Received", "Total Handled", "Total Opened", "Total Transferred", "Total Sms Handling time", "Average SMS Handling time"]
export const smsinteractionreportColumn = ["Date & Time", "Customer Name", "Customer Number", "Agent Name", "Direction", "Total Duration", "Disposition", "ACW time","Disposition Subject","Disposition Summary"]

export const emailreportcolumn = ["Date & Time", "Agent Name", "Customer Name", "Customer Email Id", "Subject", "Received On", "Assigned On", "Replied On", "Transferred On", "Disposition"]
export const egentEmailReports = ["SessionDate", "Agent Name", "Total Received", "Total Handled", "Total Opened", "Total Transferred", "Total Email Handling time", "Average Email handling time"]
export const emailinteractionreport = ["Date & Time", "Customer Email Id", "Customer Name", "Agent Name", "Direction", "Total Duration", "Disposition", "ACW time","Disposition Subject","Disposition Summary"]

export const instagramreportColumn = ["Date & Time", "Queue Name", "Agent Name", "Customer Name", "Direction", "Chat Start Time", "Chat End Time", "Duration", "Active Chat time", "Response time", "Disposition", "Disposition Subject","Disposition Summary","ACW time", "Customer Satisfaction Score"]
export const instaagentchatreportColumn = ["Date", "Queue Name", "Agent Name", "Chat Received", "Chat Handled", "Average Active Chat time", "Unanswered chat", "Average Response time"]
export const instaaCWChatReportColumn = ["Date", "Queue Name", "Agent Name", "Total Answered Chats", "Total Active Chat time", "Average Active Chat time", "Total ACW"]

export const facereportColumn = ["Date & Time", "Queue Name", "Agent Name", "Customer Name", "Direction", "Chat Start Time", "Chat End Time", "Duration", "Active Chat time", "Response time", "Disposition", "Disposition Subject","Disposition Summary","ACW time", "Customer Satisfaction Score"]
export const faceagentchatreportColumn = ["Date", "Queue Name", "Agent Name", "Chat Received", "Chat Handled", "Average Active Chat time", "Unanswered chat", "Average Response time"]
export const faceaCWChatReportColumn = ["Date", "Queue Name", "Agent Name", "Total Answered Chats", "Total Active Chat time", "Average Active Chat time", "Total ACW"]


export const whatsappreportColumn = ["Date & Time", "Queue Name", "Agent Name", "Customer Name", "Direction", "Chat Start Time", "Chat End Time", "Duration", "Active Chat time", "Response time", "Disposition", "Disposition Subject","Disposition Summary","ACW time", "Customer Satisfaction Score"]
export const whatagentchatreportColumn = ["Date", "Queue Name", "Agent Name", "Chat Received", "Chat Handled", "Average Active Chat time", "Unanswered chat", "Average Response time"]
export const aCWChatReportColumn = ["Date", "Queue Name", "Agent Name", "Total Answered Chats", "Total Active Chat time", "Average Active Chat time", "Total ACW"]
// AI&Bot
export const AIcallqualityreportColumn = ["Date & Time", "Agent Name", "Queue Name", "Contact Centre Number", "Customer Number", "Direction", "Call Quality Score", "Customer Sentiment Score", "Agent Sentiment Score", "Overall Interaction Score"]
export const AIchatqualityreportColumn = ["Date & Time", "Agent Name", "Queue Name", "Customer Name", "Channel Type", "Direction", "Chat Quality Score", "Customer Sentiment Score", "Agent Sentiment Score", "Overall Interaction Score"]
export const AgentimprovementReportColumn = ["Date", "KPI Name", "Agent Name", "Volume", "Result Value", "Goal Value", "Mean Value"]
export const AgentPerImprovementandAttainmentReport = ["Date & Time", "KPI Name", "Agent Name", "Interval Type", "Count Trend Improvement", "Count Trend Non-Improved", "Improvement", "Count Goal Met", "Count Goal Not Met", "Attainment", "Count Distinct Agent"]
export const AgentPerManResultsTrendReport = ["Date", "KPI Name", "Total Answered Chats", "Total Active Chat time", "Average Active Chat time", "Total ACW"]
export const PerfComReportBotandAgent = ["Date & Time", "Customer Name", "Bot Interaction Count", "Agent Interaction Count", "Total Interaction Count", "Bot Session Duration", "Agent Session Duration", "Total Session Duration"]
export const BotPerformanceReport = ["Date & Time", "Handled Chat", "Resolved chat", "Abandoned chat", "Auto closed by bot", "Deflected by bot", "Transferred to Agent", "Average Response Time", "Average Resolution Time"]
export const BotAccuracyReport = ["Date & Time", "Channel Type", "Queue Name", "Entity Extraction Rate", "Entity Extraction Rate Successful", "Entity Extraction Rate Unsuccessful", "Goals Completed", "Intent Recognition Rate", "Intent Recognition Rate Successful", "Intent Recognition Rate Unsuccessful", "Transfers"]


export const titleMapper: any = {
  "Date": "Date",
  "Queue Name": "queueName",
  "Agent Name": "agentName",
  "Received Calls": "receivedCall",
  "Answered Calls": "answeredCall",
  "Answered Calls %": "answeredCallPer",
  "Total Talk Time": "totalTalktime",
  "Average Talk Time": "averageTalktime",
  "Total ACW time": "totalACWtime",
  "Average ACW": "averageACW",
  AHT: "AHT",
  "Average Hold": "averageHold",
  Transferred: "transferred",
  "Transfer %": "transferper",
  "Occupancy rate": "occupancyrate",
  Agentutilization: "agentUtilization",
  "Recording Type": "recordingType",
  "Recording Duration": "recordingDuration",
  "Customer Number": "customerNumber",
  "Customer Name": "customerName",
  "Voicemail": "voicemail",
  "Voicemail Duration": "voicemailDuration",
  "Skill Name": "skillName",
  "Time": "timeFormat",
  "Chat Received": "chatReceived",
  "Chat Handled": "chatHandled",

  "Direction": "direction",
  "Total Duration": "totalDuration",
  "Queue Wait Time": "waitTime",
  "Unanswered chat": "unansweredchat",
  "Contact Centre Number": "contactCenterNumber",
  "Total ACW Time": "TotalACWTime",

  "ACW time": "ACWtime",
  "Total no of calls dialled": "totalNoOfCallsDailed",
  "Average Duration": "averageDuration",
  "Hold Time": "holdTime",
  "Average hold time": "averageHoldTime",
  // "Primary Skill": "primarySkill",
  "Primary Agent": "primaryAgent",
  // "Transferred Skill": "transferredSkill",
  "Transferred Agent": "transferredAgent",
  "Primary Queue": "primaryQueue",
  "Transferred queue": "transferredqueue",
  "Transferred Time": "transferredTime",
  "Transferred Type": "transferredType",
  "Call Distributor": "callDistributor",
  "Callback Status": "callbackStatus",
  "Request Date and time": "requestDateandtime",
  "Assigend  Agent Name": "assigendAgentName",
  "Queue Waiting time": "queueWaitingtime",
  "Callback Date and time": "callbackDateandtime",
  "Callback phone Number": "callbackphoneNumber",
  "Callback Queue phone Number": "callbackQueuephoneNumber",
  "Callback duration": "callbackduration",
  "Callback Recording": "callbackRecording",
  "Reason": "reason",
  "Call duration": "callduration",
  "ACW": "ACW",
  //agentACWchatreport
  "Queue": "queue",
  "Chat Start Time": "chatStartTime",
  "Chat End Time": "chatEndTime",
  "Duration": "duration",
  "Source": "source",
  "Active Chat time": "activeChattime",
  "Response time": "responsetime",
  "Disposition": "disposition",
  "Chat Status": "chatStatus",
  "CSAT score": "CSATscore",
  // Chatsreport
  "Total Received": "totalReceived",
  "Total Handled": "totalHandled",
  "Total Transferred chat": "totaltransferredchat",
  "Total Missed chat": "totalMissedchat",
  "Total Active Chat time": "totalActiveChatTime",
  "Average Active Chat time": "averageActiveChattime",
  "Average Response time": "averageResponsetime",
  //CallServices
  "Total Interaction": "totalInteraction",
  "Total ACW": "totalACW",
  //Agentchat
  "Routing Profile": "routingProfile",
  "Inbound calls": "inboundCalls",
  "Inbound Time": "inboundTime",
  "Outbound calls": "outboundcalls",
  "Outbound time": "outboundtime",
  "Transferred calls": "transferredcalls",
  "Total call handling time": "totalcallhandlingtime",
  "Average Call handling time": "averageCallhandlingtime",
  "Total Talk time": "totalTalktime",
  "Average talk time": "averagetalktime",
  "Average ACW time": "averageACWtime",
  "Total hold time": "totalholdtime",
  //sms
  "Date & Time": "dateTime",
  "Received On": "receivedOn",
  "Assigned On": "assignedOn",
  "Replied On": "repliedOn",
  "Transferred On": "transferredOn",
  "Discarded On": "discardedOn",
  "Total Recevived": "totalRecevived",
  "Total handled": "totalHandled",
  "Total Opened": "totalOpened",
  "Total Transferred": "totalTransferred",
  "Total Discarded": "totalDiscarded",
  "Total Sms Handling time": "totalSmsHandlingTime",
  "Average SMS Handling time": "averageSMSHandlingTime",
  //email
  "SessionDate": "sessionDate",
  "Customer Email Id": "customerEmailId",
  "Subject": "subject",
  "Discarded": "discarded",
  "Total Email Handling time": "totalEmailHandlingTime",
  "Average Email handling time": "averageEmailHandlingTime",
  "Disposition status": "dispositionstatus",
  "Total Answered Chats": "totalAnsweredChats",
  "Customer Satisfaction Score": "customerSatisfactionScore",
  "Country": "country",
  "Call Type": "callType",
  "Rate Per Minute": "ratePerMinute",
  "Total Call cost": "totalCallcost",
  "Primary Agent Handling Time": "primaryAgentHandlingTime",
  "Last Transferred Agent": "lastTransferredAgent",
  "Last Agent Handling Time": "lastAgentHandlingTime",
  "No of Handling Time": "noofHandlingTime",
  "Total Call Duration": "totalCallDuration",
  "Total Hold Time": "totalHoldTime",
  "Total Wrap up Time": "totalWrapUpTime",
  //Agent
  "Average speed of answer": "averagespeedofanswer",
  "Service Level": "serviceLevel",
  "Resolved queries": "resolvedqueries",
  "Inbounds": "inbounds",
  "Outbounds": "outbounds",
  "Total handling time": "totalhandlingtime",
  "Average handling time": "averagehandlingtime",
  "Average Speed of answer": "averageSpeedofanswer",
  "Login Date / Time": "loginTime",
  "Logout Date / Time": "logoutTime",
  // "Agent Login Details": "agentLoginDetails",
  // "Agent Logout Details": "agentLogoutDetails",
  "Logged-In Duration": "loggedInDuration",
  "Available Time": "availableTime",
  "Unavailable time": "unavailabletime",
  "Total Logged-in Time": "totalLoggedinTime",
  "Ready": "ready",
  "Ready %": "readyper",
  "Not Ready": "notReady",
  "Not Ready %": "notReadyper",
  "Away": "away",
  "Away %": "awayper",
  "Transfer Only": "transferOnly",
  "Transfer Only %": "transferOnlyper",
  "Busy Time": "busyTime",
  "Busy Time %": "busyTimeper",
  "Custom State": "customState",
  "Custom State %": "customStateper",
  "Channel": "channel",
  "Customer NameNumber": "customerNameNumber",
  "CSAT Question": "CSATQuestion",
  "Start Time": "startTime",
  "End Time": "endTime",
  "No of Handling Attempts": "noofHandlingAttempts",
  "Agent Id":"AgentId",

  //AI&bot
  "Call Quality Score": "callQualityScore",
  "Chat Quality Score": "chatQualityScore",
  "Customer Sentiment Score": "customerSentimentScore",
  "Agent Sentiment Score": "agentSentimentScore",
  "Overall Interaction Score": "overallInteractionScore",
  "Channel Type": "ChannelType",
  "KPI Name": "KPIName",
  "Volume": "volume",
  "Result Value": "resultValue",
  "GoalValue": "goalValue",
  "Mean Value": "meanValue",
  "Interval Type": "intervalType",
  "Count Trend Improvement": "countTrendImprovement",
  "Count Trend Non-Improved": "countTrendNonImproved",
  "Improvement": "improvement",
  "Count Goal Met": "countGoalMet",
  "Count Goal Not Met": "countGoalNotMet",
  "Attainment": "attainment",
  "Count Distinct Agent": "countDistinctAgent",
  "Bot Interaction Count": "botInteractionCount",
  "Agent Interaction Count": "agentInteractionCount",
  "Total Interaction Count": "TotalInteractionCount",
  "Bot Session Duration": "botSessionDuration",
  "Agent Session Duration": "agentSessionDuration",
  "Total Session Duration": "TotalSessionDuration",
  "Handled Chat": "handledChat",
  "Resolved chat": "resolvedchat",
  "Abandoned chat": "abandonedchat",
  "Auto closed by bot": "autoclosedbybot",
  "Deflected by bot": "deflectedbybot",
  "Transferred to Agent": "transferredtoAgent",
  "Average Response Time": "averageResponseTime",
  "Average Resolution Time": "averageResolutionTime",
  "Disposition Subject": "DispositionSubject",
  "Disposition Summary": "DispositionSummary",
  "Custom Time":"CustomTime",


};

export const columnLableList: any = {
  Date: "Date",
  queueName: "Queue Name",
  agentName: "Agent Name",
  receivedCall: "Received Calls",
  answeredCall: "Answered Calls",
  answeredCallPer: "Answered Calls %",
  totalTalktime: "Total Talk Time",
  averageTalktime: "Average Talk Time",
  totalACWtime: "Total ACW time",
  averageACW: "Average ACW",
  AHT: "AHT",
  averageHold: "Average Hold",
  transferred: "Transferred",
  transferper: "Transfer %",
  occupancyrate: "Occupancy rate",
  agentUtilization: "AgentUtilization",
  recordingType: "Recording Type",
  recordingDuration: "Recording Duration",
  customerNumber: "Customer Number",
  customerName: "Customer Name",
  TotalACWTime: "Total ACW Time",
  voicemail: "Voicemail",
  voicemailDuration: "Voicemail Duration",
  noofHandlingAttempts: "No of Handling Attempts",
  chatHandled: "Chat Handled",

  timeFormat: "Time",
  direction: "Direction",
  totalDuration: "Total Duration",
  waitTime: "Queue Wait Time",
  totalAnsweredChats: "Total Answered Chats",
  ACWtime: "ACW time",
  totalNoOfCallsDailed: "Total no of calls dialled",
  averageDuration: "Average Duration",
  holdTime: "Hold Time",
  averageHoldTime: "Average hold time",
  primaryAgent: "Primary Agent",
  transferredSkill: "Transferred Skill",
  transferredAgent: "Transferred Agent",
  primaryQueue: "Primary Queue",
  transferredqueue: "Transferred queue",
  transferredTime: "Transferred Time",
  transferredType: "Transferred Type",
  callDistributor: "Call Distributor",
  callbackStatus: "Callback Status",
  requestDateandtime: "Request Date and time",
  assigendAgentName: "Assigend Agent Name",
  queueWaitingtime: "Queue Waiting time",
  callbackDateandtime: "Callback Date and time",
  callbackphoneNumber: "Callback phone Number",
  callbackQueuephoneNumber: "Callback Queue phone Number",
  callbackduration: "Callback duration",
  callbackRecording: "Callback Recording",
  reason: "Reason",
  chatReceived: "Chat Received",
  callduration: "Call duration",
  dispositionstatus: "Disposition status",
  ACW: "ACW",
  queue: "Queue",
  chatStartTime: "Chat Start Time",
  chatEndTime: "Chat End Time",
  duration: "Duration",
  source: "Source",
  activeChattime: "Active Chat time",
  responsetime: "Response time",
  disposition: "Disposition",
  chatStatus: "Chat Status",
  CSATscore: "CSAT score",
  totalReceived: "Total Received",
  totalHandled: "Total Handled",
  totaltransferredchat: "Total Transferred chat",
  totalMissedchat: "Total Missed chat",
  totalActiveChatTime: "Total Active Chat time",
  averageActiveChattime: "Average Active Chat time",
  averageResponsetime: "Average Response time",
  totalInteraction: "Total Interaction",
  totalACW: "Total ACW",
  unansweredchat: "Unanswered chat",

  dateTime: "Date & Time",
  receivedOn: "Received On",
  assignedOn: "Assigned On",
  repliedOn: "Replied On",
  transferredOn: "Transferred On",
  discardedOn: "Discarded On",
  totalRecevived: "Total Recevived",
  totalOpened: "Total Opened",
  totalTransferred: "Total Transferred",
  totalDiscarded: "Total Discarded",
  totalSmsHandlingTime: "Total Sms Handling time",
  averageSMSHandlingTime: "Average SMS Handling time",
  averageEmailHandlingTime: "Average Email handling time",
  customerEmailId: "Customer Email Id",
  subject: "Subject",
  discarded: "Discarded",
  totalEmailHandlingTime: "Total Email Handling time",
  sessionDate: "SessionDate",
  customerSatisfactionScore: "Customer Satisfaction Score",
  contactCenterNumber: "Contact Centre Number",
  country: "Country",
  callType: "Call Type",
  ratePerMinute: "Rate Per Minute",
  totalCallcost: "Total Call cost",
  primaryAgentHandlingTime: "Primary Agent Handling Time",
  lastTransferredAgent: "Last Transferred Agent",
  lastAgentHandlingTime: "Last Agent Handling Time",
  noofHandlingTime: "No of Handling Time",
  totalCallDuration: "Total Call Duration",
  totalHoldTime: "Total Hold Time",
  totalWrapUpTime: "Total Wrap up Time",
  routingProfile: "Routing Profile",
  inboundCalls: "Inbound calls",
  inboundTime: "Inbound Time",
  outboundcalls: "Outbound calls",
  outboundtime: "Outbound time",
  transferredcalls: "Transferred calls",
  totalcallhandlingtime: "Total call handling time",
  averageCallhandlingtime: "Average Call handling time",
  averagetalktime: "Average talk time",
  averageACWtime: "Average ACW time",
  totalholdtime: "Total hold time",
  startTime: "Start Time",
  endTime: "End Time",


  averagespeedofanswer: "Average speed of answer",
  serviceLevel: "Service Level",
  resolvedqueries: "Resolved queries",
  inbounds: "Inbounds",
  outbounds: "Outbounds",
  totalhandlingtime: "Total handling time",
  averagehandlingtime: " Average handling time",
  averageSpeedofanswer: "Average Speed of answer",
  loginTime: "Login Date / Time",
  logoutTime: "Logout Date / Time",
  // agentLoginDetails: "Agent Login Details",
  // agentLogoutDetails: "Agent Logout Details",
  loggedInDuration: " Logged-In Duration",
  availableTime: "Available Time",
  unavailabletime: "Unavailable time",
  totalLoggedinTime: "Total Logged-in Time",
  ready: "Ready",
  readyper: "Ready%",
  notReady: "Not Ready",
  notReadyper: "Not Ready%",
  away: "Away",
  awayper: "Away%",
  transferOnly: "TransferOnly",
  transferOnlyper: "TransferOnly%",
  busyTime: "Busy Time",
  busyTimeper: "Busy Time%",
  customState: "CustomState",
  customStateper: "CustomState%",
  channel: "Channel",
  customerNameNumber: "Customer NameNumber",
  CSATQuestion: "CSAT Question",
  callQualityScore: "Call Quality Score",
  chatQualityScore: "Chat Quality Score",
  customerSentimentScore: "Customer Sentiment Score",
  agentSentimentScore: "Agent Sentiment Score",
  overallInteractionScore: "Overall Interaction Score",
  ChannelType: "Channel Type",
  KPIName: "KPI Name",
  volume: "Volume",
  resultValue: "Result Value",
  goalValue: "Goal Value",
  meanValue: "Mean Value",
  intervalType: "Interval Type",
  countTrendImprovement: "Count Trend Improvement",
  countTrendNonImproved: "Count Trend Non-Improved",
  improvement: "improvement",
  countGoalMet: "Count Goal Met",
  countGoalNotMet: "Count Goal Not Met",
  attainment: "Attainment",
  countDistinctAgent: "Count Distinct Agent",
  handledChat: "Handled Chat",
  resolvedchat: "Resolved chat",
  abandonedchat: "Abandoned chat",
  autoclosedbybot: "Auto closed by bot",
  deflectedbybot: "Deflected by bot",
  transferredtoAgent: "Transferred to Agent",
  averageResponseTime: "Average Response Time",
  averageResolutionTime: "Average Resolution Time",
  botInteractionCount: "Bot Interaction Count",
  botSessionDuration: "Bot Session Duration",
  agentInteractionCount: "Agent Interaction Count",
  TotalInteractionCount: "Total Interaction Count",
  agentSessionDuration: "Agent Session Duration",
  TotalSessionDuration: "Total Session Duration",
  DispositionSubject: "Disposition Subject",
  DispositionSummary: "Disposition Summary",
  CustomTime: "Custom Time",
  AgentId:"AgentId"

};

export const getFilterOptionData = (voiceFilterOpt: any, data: any, page: any) => {

  const body = {
    limit: voiceFilterOpt?.limit || 100,
    timeZone: null,
    offset: voiceFilterOpt?.offset || 0,
    queueName: voiceFilterOpt.queueList?.length === 0 ? '' : voiceFilterOpt.selectedQueuetList?.toString(),
    agentName: voiceFilterOpt.agentList?.length === 0 ? '' : voiceFilterOpt.selectedAgentList?.toString(),
    transferredType: voiceFilterOpt.Transferredtype?.length === 0 ? '' : voiceFilterOpt.selectedTransferredlist?.toString(),
    direction: voiceFilterOpt.directionList?.length === 0 ? '' : voiceFilterOpt.selecteddirectionlist?.toString(),
    disposition: voiceFilterOpt.dispostionList?.length === 0 ? '' : voiceFilterOpt.selecteddispostionlist.toString(),
    endTmpstmp: voiceFilterOpt?.endDateTime ? voiceFilterOpt.endDateTime : new Date().getTime(),
    startTmpstmp: voiceFilterOpt?.startDateTime ? voiceFilterOpt.startDateTime : moment().subtract(100, 'days').valueOf(),
    voiceMail: voiceFilterOpt?.selectedVoiceMail ?? null
  };

  return body;

};


export const apireports = (voiceReportKeys: any,) => {


  let overAllUrl =
    voiceReportKeys === "acr_report" ? "get_answered_call_profile" :
      voiceReportKeys === "mc_report" ? "get_missedCall_list" :
        voiceReportKeys === "obc_report" ? "outbound_call_report" :
         voiceReportKeys === "icr_report" ? "inbound_call_report" :
          voiceReportKeys === "inter_report" ? "interaction_list" :
            voiceReportKeys === "tc_report" ? "transfer_call_report" :
              voiceReportKeys === "sms_report" ? "get_sms_profile_report" :
                voiceReportKeys === "agsms_report" ? "get_sms_agent_report" :
                  voiceReportKeys === "interaction_report" ? "get_sms_interation_report" :
                    voiceReportKeys === "c_report" ? "get_chat_profile_report" :
                      voiceReportKeys === "tac_report" ? "get_chat_agent_report" :
                        voiceReportKeys === "agchat_report" ? "get_chat_agent_acw_report" :
                          voiceReportKeys === "E_report" ? "get_email_profile_report" :
                            voiceReportKeys === "agemail_report" ? "get_email_agent_report" :
                              voiceReportKeys === "interemail_report" ? "get_email_interation_report" :
                                voiceReportKeys === "wh_report" ? "get_socialmedia_profile_report" :
                                  voiceReportKeys === "agwhat_report" ? "get_socialmedia_agent_report" :
                                    voiceReportKeys === "acwwhat_report" ? "get_whatsapp_ACW_report" :
                                      voiceReportKeys === "cs_report" ? "get_call_back_summary" :
                                        voiceReportKeys === "agentCS_report" ? "get_agent_call_summary_report" :
                                          voiceReportKeys === "agentP_report" ? "get_agent_performance" :
                                            voiceReportKeys === "queryHT_report" ? "get_query_handing_time_report" :
                                              voiceReportKeys === "loginL_report" ? "get_login_and_logout_report" :
                                                voiceReportKeys === "agentS_report" ? "get_agent_status_report" :
                                                  voiceReportKeys === "feedback_report" ? "get_csat_agent_feedback_report" :
                                                    voiceReportKeys === "in_report" ? "get_instagram_profile_report" :
                                                      voiceReportKeys === "inagwhat_report" ? "get_instagram_ACW_report" :
                                                        voiceReportKeys === "inacwwhat_report" ? "get_instagram_Agent_ACW_report" :
                                                          voiceReportKeys === "face_report" ? "get_facebook_report" :
                                                            voiceReportKeys === "faceagwhat_report" ? "get_facebook_Agent_report" :
                                                              voiceReportKeys === "faceacwwhat_report" ? "get_facebook_Agent_ACW_report" :
                                                                voiceReportKeys === "aicq_report" ? "get_ai_call_quality_report" :
                                                                  voiceReportKeys === "aichq_report" ? "get_ai_chat_quality_report" :
                                                                    voiceReportKeys === "apmra_report" ? "get_agent_performance_management_result_analysis_report" :
                                                                      voiceReportKeys === "apia_report" ? "get_agent_performance_improvement_and_attainment_report" :
                                                                        voiceReportKeys === "apmrt_report" ? "get_agent_performance_management_results_trend_report" :
                                                                          voiceReportKeys === "pcrba_report" ? "get_ai_bot_performances_bot_agent_report" :
                                                                            voiceReportKeys === "botp_report" ? "get_ai_bot_performances_report" :
                                                                              voiceReportKeys === "bard_report" ? "get_bot_accuracy_report" : "get_ai_call_quality_report"

  return overAllUrl;
};
export const millisecondsToTime = (milliseconds: any) => {
  if(!milliseconds){
    return '00:00:00'
  }
  const time = new Date(milliseconds);
  const hours = Math.floor(milliseconds / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export const SecondsToTime = (seconds: any) => {
  const duration = moment.duration(seconds, 'seconds');
  const hours = Math.floor(duration.asHours());
  const minutes = Math.floor(duration.asMinutes()) % 60;
  const secondsc = Math.floor(duration.asSeconds()) % 60;

  const formattedTime = moment()
    .hours(hours)
    .minutes(minutes)
    .seconds(secondsc)
    .format('HH:mm:ss');

  return formattedTime;
}
export const minutestotime = (minutes: any) => {
  const minutess = Math.floor(minutes / 60);
  const seconds = minutes % 60;

  const formattedTime = moment()

    .minutes(minutess)
    .seconds(seconds)
    .format('mm:ss');
  return formattedTime;
}

function formatDate(dateString: any) {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
}

const timeTotwelveHoursFormat = (data: any) => {
  const formatted = moment(data).format("HH:mm:ss");
  const [hours, minutes, seconds] = formatted.split(":").map(Number);
  const time = new Date(2000, 0, 1, hours, minutes, seconds);
  const formattedTime = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  return formattedTime;
}

const handleBrowser = (data: any) => {
  if (data == "Chrome")
    return "Web"
  else
    return "App"
}

const CSATQuestion = (data :any) => {
  try {
    if(!isJSON(data)) return 0;
    let parsed = JSON.parse(data)
    if(!parsed) return 0;
    if(Array.isArray(parsed)){
      return parsed?.length
    } else if(!_.isEmpty(parsed)){
      return 1
    }
    return 0 
  } catch (error) {
    return 0
  }
}


export const reportMappedValiue = (reportList: any, checkWebChatUrl: any) => {
  const planId = GetItemFromStorage(LocalStorage.PLAN_ID);
  const planCheck = (planId == 54 || planId == 107 || planId == 103 || planId == 32 || planId == 141);
  const reportData: any = [];

  const getDefaultQueue = (value: any) => {
    return (checkWebChatUrl && !planCheck && (!value || value === '-'))
      ? '-'
      : (value ?? '-')
  }

  reportList.map((data: any) => {
    reportData.push({
      AHT: data.AHT ? SecondsToTime(data.AHT) : "-",
      agentName: data.agentName ?? "-",
      agentUtilization: data.agentUtilization ? `${Math.round(data.agentUtilization / 10)}%` : "-",
      answeredCall: data.answeredCall ?? "-",
      answeredCallPer: data.answeredCallPer ? `${Math.round(data.answeredCallPer)}%` : "-",
      averageACW: data.averageACW !== null ? SecondsToTime(data.averageACW) : "-",
      averageHold: data.averageHold !== null ? SecondsToTime(data.averageHold) : "-",
      averageTalktime: data.averageTalktime !== null ? SecondsToTime(data.averageTalktime) : "-",
      occupancyrate: data.occupancyrate ? `${Math.round(data.occupancyrate)}%` : "-",
      queueName: getDefaultQueue(data.queueName),
      receivedCall: data.receivedCall ?? "-",
      outbounds: data.outbounds ?? "-",
      recordingDuration: data.recordingDuration ? formatTime(Math.ceil(data.recordingDuration / 1000)) : "-",
      recordingType: data.recordingType ?? "-",
      // sessionStartTime: moment(data.sessionStartTime).format("DD/MM/yyyy") ?? "-",
      totalACWtime: data.totalACWtime  ? SecondsToTime(data.totalACWtime) : "-",
      totalTalktime: data.totalTalktime !== null ? SecondsToTime(data.totalTalktime) : "-",
      transferper: data.transferper ? `${data.transferper}%` : "-",
      transferred: data.transferred ?? "-",
      inbounds: data.inbounds ?? "-",
      requestDateandtime: moment(data.requestDateandtime).format("DD-MM-YYYY hh:mm A") ?? "-",
      averageSpeedofanswer: data.averageSpeedofanswer !== null ? SecondsToTime(data.averageSpeedofanswer) : "-",
      customerName: data.customerName != null ? data.customerName : "New Customer",
      customerNumber: data.customerNumber ?? "-",
      Date: data.date ? formatDate(data.date) : data.Date ? formatDate(data.Date) : data.sessionDate ? formatDate(data.sessionDate) : "-",
      queueWaitingtime: data.queueWaitingTime ? SecondsToTime(data.queueWaitingTime) 
                        : data.queueWaitingtime  ? SecondsToTime(data.queueWaitingtime) : "-",
      timeFormat: moment(data.timeFormat).format("hh:mm:ss A") ?? "-",
      time: moment(data.time).format("hh:mm:ss A") ?? "-",
      direction: data.direction ?? "-",
      totalDuration: data.totalDuration ? SecondsToTime(data.totalDuration) : "-",
      waitTime: data.queueWaitTime ?? "-",
      dispositionStatus: data.dispositionStatus ?? "-",
      dispositionstatus: data.dispositionstatus ?? "-",
      CSATQuestion: CSATQuestion(data.CSATQuestion),
      CSATQuestionData: data.CSATQuestion ?? 0,
      ratingType:data?.ratingType ?? null,
      ACWtime: data.ACWtime !== null ? SecondsToTime(data.ACWtime) : "-",
      TotalACWTime: data.TotalACWTime ? SecondsToTime(data.TotalACWTime) : "-",
      primarySkill: data.primarySkill ?? "-",
      primaryAgent: data.primaryAgent ?? "-",
      primaryQueue: data.primaryQueue ?? "-",
      transferredSkill: data.transferredSkill ?? "-",
      transferredAgent: data.transferredAgent ?? "-",
      transferredqueue: data.transferredqueue ?? "-",
      transferredTime: data.transferredTime ?? "-",
      transferredType: data.transferredType ?? "-",
      callduration: data.callDuration !== null ? millisecondsToTime(data.callDuration) : "-",
      totalAnsweredChats: data.totalAnsweredChats ?? "-",
      callbackduration: data.callBackduration !== null ? SecondsToTime(data.callBackduration) : "-",
      callbackQueuephoneNumber: data.callbackQueuephoneNumber || "-",
      noofHandlingAttempts: data.noofHandlingAttempts ?? "-",
      Country: data.Country ?? "-",
      resolvedqueries: data.resolvedqueries !== null ? `${Math.round(data.resolvedqueries)}%` : "-",
      ACW: SecondsToTime(data.ACW) ?? "-",
      voicemail: data.voicemail ?? "-",
      voicemailDuration: data.voicemailDuration ?? "-",
      dateTime: moment(data.dateTime).format("DD-MM-YYYY hh:mm A") ?? "-",
      sessionDate: data?.sessionDate > 9999999999 ? moment(data?.sessionDate).format("DD-MM-YYYY") ?? "-" : moment(data?.sessionDate * 1000).format("DD-MM-YYYY") ?? "-",
      //new

      receivedOn: moment(data.receivedOn).format("DD-MM-YYYY hh:mm") ?? "-",
      queue: data.queue ?? "-",
      chatStartTime: data.chatStartTime !== null ? timeTotwelveHoursFormat(data?.chatStartTime) : "-",
      chatEndTime: ![0, "0", null].includes(data.chatEndTime) ? timeTotwelveHoursFormat(data?.chatEndTime) : "-",
      source: data.source ? handleBrowser(data.source) : "-",
      customerEmailId: (data.customerEmailId?.split(',').filter((d: any) => d).join()) ?? "-",
      callbackphoneNumber: data.callbackphoneNumber ?? "-",
      activeChattime: data.activeChattime ? SecondsToTime(data.activeChattime) : "-",
      responsetime: data.responseTime ? SecondsToTime(data.responseTime) : "-",
      disposition: data.disposition ?? "-",
      chatStatus: data.chatStatus ?? "-",
      CSATscore: data.CSATscore ?? 0,
      totalReceived: data.totalReceived ?? "-",
      unansweredchat: data.unansweredchat ?? "-",
      callbackDateandtime: data.callbackDateandtime !== null ? moment(data.callbackDateandtime).format("DD-MM-YYYY hh:mm A") : "-",
      contactCenterNumber: data.contactCenterNumber ?? "-",
      channel: data.channel ?? "-",
      startTime: data.dateTime !== null ? moment(data.dateTime).format("hh:mm:ss ") : "-",
      endTime: data.endTime !== null ? moment(data.endTime).format("hh:mm:ss ") : "-",
      customerSatisfactionScore: data.customerSatisfactionScore ?? "-",
      totalHandled: data.totalHandled ?? "-",
      totaltransferredchat: data.totaltransferredchat ?? "-",
      totalMissedchat: data.totalMissedChat ?? "-",
      totalActiveChatTime: data.totalActiveChatTime !== null && data.totalActiveChatTime > 0 ? millisecondsToTime(data.totalActiveChatTime) : "-",
      averageActiveChattime: data.avgActiveChatTime ? millisecondsToTime(data.avgActiveChatTime) : data.averageActiveChatTime ? millisecondsToTime(data.averageActiveChatTime) : data.averageActiveChattime && data.averageActiveChattime > 0 ? millisecondsToTime(data.averageActiveChattime) : "-",
      averageResponsetime: data.averageResponseTime ? SecondsToTime(data.averageResponseTime) : data.averageResponsetime ? SecondsToTime(data.averageResponsetime) : "-",
      totalInteraction: data.totalInteraction ?? "-",
      totalACW: data.totalACW !== null ? SecondsToTime(data.totalACW) : "-",
      callType: data.callType ?? "-",
      chatReceived: data.chatReceived ?? "-",
      chatHandled: data.chatHandled ?? "-",
      ratePerMinute: data.ratePerMinute ?? "-",
      duration: data.duration ? millisecondsToTime(data.duration) : "-",
      totalCallcost: data.totalCallcost ?? "-",
      primaryAgentHandlingTime: data.primaryAgentHandlingTime !== null ? SecondsToTime(data.primaryAgentHandlingTime) : "-",
      lastTransferredAgent: data.lastTransferredAgent ?? "-",
      averagehandlingtime: data.averagehandlingtime !== null ? SecondsToTime(data.averagehandlingtime) : "-",
      lastAgentHandlingTime: data.lastAgentHandlingTime !== null ? SecondsToTime(data.lastAgentHandlingTime) : "-",
      noofHandlingTime: data.noofHandlingTime !== null ? SecondsToTime(data.noofHandlingTime) : "-",
      totalCallDuration: data.totalCallDuration !== null ? SecondsToTime(data.totalCallDuration) : "-",
      totalHoldTime: data.totalHoldTime !== null ? SecondsToTime(data.totalHoldTime) : "-",
      totalWrapUpTime: data.totalWrapUpTime !== null ? SecondsToTime(data.totalWrapUpTime) : "-",
      //sms
      // customerEmailIds: data.customerEmailIds ?? "-",
      subject: data.subject ?? "-",
      discarded: data.discarded ?? "-",
      totalEmailhandlingtime: data.totalEmailhandlingtime !== null ? moment(data.totalEmailhandlingtime).format(" hh:mm:ss ") : "-",
      assignedOn: data.assignedOn !== null ? moment(data.assignedOn).format("DD-MM-YYYY hh:mm") : "-",
      repliedOn: data.repliedOn !== null ? moment(data.repliedOn).format("DD-MM-YYYY hh:mm") : "-",
      transferredOn: data.transferredOn !== null ? moment(data.transferredOn).format("DD-MM-YYYY hh:mm") : "-",
      discardedOn: data.discardedOn ?? "-",
      totalRecevived: data.totalRecevived ?? "-",
      totalOpened: data.totalOpened ?? "-",
      totalTransferred: data.totalTransferred ?? "-",
      totalDiscarded: data.totalDiscarded ?? "-",
      totalSmsHandlingTime: data.totalSmsHandlingTime !== null ? millisecondsToTime(data.totalSmsHandlingTime) : "-",
      averageEmailHandlingTime: data.averageEmailHandlingTime !== null ? millisecondsToTime(data.averageEmailHandlingTime) : "-",
      averageSMSHandlingTime: data.averageSMSHandlingTime !== null ? millisecondsToTime(data.averageSMSHandlingTime) : "-",
      totalEmailHandlingTime: data.totalEmailHandlingTime !== null ? millisecondsToTime(data.totalEmailHandlingTime) : "-",


      //agent
      unavailabletime: data.unavailabletime !== null ? SecondsToTime(data.unavailabletime) : "-",
      availableTime: data.availableTime !== null ? SecondsToTime(data.availableTime) : "-",
      loggedInDuration: data.loggedInDuration !== null ? SecondsToTime(data.loggedInDuration) : "-",
      logoutTime: data.logoutTime !== null ? moment(data.logoutTime).format('DD-MM-YYYY / HH:mm:ss') : "-",
      // agentLoginDetails: data.agentLoginDetails !== null ? SecondsToTime(data.agentLoginDetails) : "-",
      // agentLogoutDetails: data.agentLogoutDetails !== null ? SecondsToTime(data.agentLogoutDetails) : "-",
      loginTime: data.loginTime ? moment(data.loginTime).format('DD-MM-YYYY / HH:mm:ss') : "-",
      averageHoldTime: data.averageHoldTime !== null ? SecondsToTime(data.averageHoldTime) : "-",
      serviceLevel: data.serviceLevel !== null ? `${Math.round(data.serviceLevel)}%` : "-",
      routingProfile: data.routingProfile ?? "-",
      averagespeedofanswer: data.averagespeedofanswer !== null ? SecondsToTime(data.averagespeedofanswer) : "-",
      inboundCalls: data.inboundCalls ?? "-",
      inboundTime: data.inboundTime !== null ? SecondsToTime(data.inboundTime) : "-",
      outboundcalls: data.outboundcalls ?? "-",
      outboundtime: data.outboundtime !== null ? SecondsToTime(data.outboundtime) : "-",
      transferredcalls: data.transferredcalls ?? "-",
      totalhandlingtime: data.totalhandlingtime !== null ? SecondsToTime(data.totalhandlingtime) : "-",
      totalcallhandlingtime: data.totalcallhandlingtime !== null ? SecondsToTime(data.totalcallhandlingtime) : "-",
      averageCallhandlingtime: data.averageCallhandlingtime !== null ? SecondsToTime(data.averageCallhandlingtime) : "-",
      averagetalktime: data.averagetalktime !== null ? SecondsToTime(data.averagetalktime) : "-",
      averageACWtime: data.averageACW !== null ? SecondsToTime(data.averageACW) : "-",
      totalholdtime: data.totalHoldTime !== null ? SecondsToTime(data.totalHoldTime) : "-",
      callQualityScore: data.callQualityScore ?? "-",
      chatQualityScore: data.chatQualityScore ?? "-",
      customerSentimentScore: data.customerSentimentalScore ?? "-",
      agentSentimentScore: data.agentSentimentalScore ?? "-",
      overallInteractionScore: data.overallInteractionScore ?? "-",
      ChannelType: data.channelType ?? "-",
      KPIName: data.KPIName ?? "-",
      volume: data.volume ?? "-",
      resultValue: data.resultValue ?? "-",
      goalValue: data.goalValue ?? "-",
      meanValue: data.meanValue ?? "-",
      intervalType: data.intervalType ?? "-",
      countTrendImprovement: data.countTrendImprovement ?? "-",
      countTrendNonImproved: data.countTrendNonImproved ?? "-",
      improvement: data.improvement ?? "-",
      countGoalMet: data.countGoalMet ?? "-",
      countGoalNotMet: data.countGoalNotMet ?? "-",
      attainment: data.attainment ?? "-",
      handledChat: data.handledChat ?? "-",
      resolvedchat: data.resolvedChat ?? "-",
      autoclosedbybot: data.autoClosedByBot ?? "-",
      abandonedchat: data.abandonedChat ?? "-",
      deflectedbybot: data.deflectedByBot ?? "-",
      transferredtoAgent: data.transferredToAgent ?? "-",
      averageResponseTime: data.averageResponsesTime !== null ? SecondsToTime(data.averageResponsesTime) : "-",
      averageResolutionTime: data.averageResolutionTime !== null ? millisecondsToTime(data.averageResolutionTime) : "-",
      countDistinctAgent: data.countDistinctAgent ?? "-",
      callDistributor: data.callDistributor ?? "-",
      callbackStatus: data.callbackStatus ?? "-",
      botInteractionCount: data.BotInteractionCount ?? "-",
      agentInteractionCount: data.agentInteractionCount ?? "-",
      TotalInteractionCount: data.TotalInteractionCount ?? "-",
      botSessionDuration: data.botSessionDuration !== null ? millisecondsToTime(data.botSessionDuration) : "-",
      agentSessionDuration: data.agentSessionDuration !== null ? millisecondsToTime(data.agentSessionDuration) : "-",
      TotalSessionDuration: data.TotalSessionDuration !== null ? millisecondsToTime(data.TotalSessionDuration) : "-",
      totalLoggedinTime: data.totalLoggedinTime !== null ? SecondsToTime(data.totalLoggedinTime) : "-",
      ready: data.ready !== null ? SecondsToTime(data.ready) : "-",
      readyper: data.readyper !== null ? `${Math.round(data.readyper)}%` : "-",
      notReady: data.notReady !== null ? SecondsToTime(data.notReady) : "-",
      notReadyper: data.notReadyper !== null ? `${Math.round(data.notReadyper)}%` : "-",
      away: data.away !== null ? SecondsToTime(data.away) : "-",
      awayper: data.awayper !== null ? `${Math.round(data.awayper)}%` : "-",
      transferOnly: data.transferOnly !== null ? SecondsToTime(data.transferOnly) : "-",
      transferOnlyper: data.transferOnlyper !== null ? `${Math.round(data.transferOnlyper)}%` : "-",
      busyTime: data.busyTime !== null ? SecondsToTime(data.busyTime) : "-",
      busyTimeper: data.busyTimeper !== null ? `${Math.round(data.busyTimeper)}%` : "-",
      customState: data.customState !== null ? SecondsToTime(data.customState) : "-",
      customStateper: data.customStateper !== null ? `${Math.round(data.customStateper)}%` : "-",
      DispositionSubject: data?.subject ?? '-',
      DispositionSummary: data?.summary ?? '-',
      CustomTime: data.customTime !== null ? SecondsToTime(data.customTime) : "-",
      AgentId:data?.AgentId ?? '-'



    })
  })
  return reportData;
}
export const mapForTablesFormat = (data: any) => {
  const mappedData = [];
  for (let each of data) {
    if (each !== "All") {
      mappedData.push(titleMapper[each?.trim()] ?? "");
    }
  }
  return mapForColumnWithResult(mappedData);
};

export const mapForColumnWithResult = (data: any) => {
  const columnsList = [];
  for (let each of data) {
    columnsList.push({
      title: columnLableList[`${each}`?.trim()],
      dataIndex: each,
      key: each,
      sorter: (a: any, b: any) => JSON.stringify(a[`${each}`?.trim()]).localeCompare(JSON.stringify(b[`${each}`?.trim()])),
    });
  }

  return columnsList;
};

export const formatTime = (seconds: any) => {
  const hours = Math.floor(seconds / 3600);
  const remainingSeconds = seconds - hours * 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  const secondsData = remainingSeconds - minutes * 60;

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${secondsData.toString().padStart(2, "0")}`;
};

export const reportNavigation: any = [
  { acr_report: "Answered", answeredCallReportColumn: answeredCallReportColumn },
  { icr_report: "Inbound", inboundCallReportColumn: inboundCallReportColumn },
  { mc_report: "Missed", missedCallReportColumns: missedCallReportColumns },
  { inter_report: "Interaction", interactionReportColumn: interactionReportColumn },//Interaction No data
  { obc_report: "Outbound", outBoundReportColumn: outBoundReportColumn },
  { tc_report: "Transfercall", transfercallReportColumn: transfercallReportColumn },
  { agchat_report: "AgentACWchatreport", agentACWchatreport: agentACWchatreportColumn },
  { c_report: "Chatsreport", chatsreportColum: chatsreportColumn },
  { tac_report: "AgentChatReport", agentChatReport: agentChatReportColumn },
  { sms_report: "Smsreport", smsreportColumn: smsreportColumn },
  { agsms_report: "Agentsmsreport", agentsmsreportColumn: agentsmsreportColumn },
  { interaction_report: "Interactionreport", smsinteractionreportColumn: smsinteractionreportColumn },
  { E_report: "E_report", emailreportcolumn: emailreportcolumn },
  { agemail_report: "agemail_report", egentEmailReports: egentEmailReports },
  { interemail_report: "interemail_report", emailinteractionreport: emailinteractionreport },
  { wh_report: "wh_report", whatsappreportColumn: whatsappreportColumn },
  { agwhat_report: "agwhat_report", whatagentchatreportColumn: whatagentchatreportColumn },
  { acwwhat_report: "acwwhat_report", aCWChatReportColumn: aCWChatReportColumn },
  { cs_report: "CallBacksummaryreport", getCallBacksummaryreport: getCallBacksummaryreport },
  { in_report: "in_report", instagramreportColumn: instagramreportColumn },
  { inagwhat_report: "inagwhat_report", instaagentchatreportColumn: instaagentchatreportColumn },
  { inacwwhat_report: "inacwwhat_report", instaaCWChatReportColumn: instaaCWChatReportColumn },
  { face_report: "face_report", facereportColumn: facereportColumn },
  { faceagwhat_report: "faceagwhat_report", faceagentchatreportColumn: faceagentchatreportColumn },
  { faceacwwhat_report: "faceacwwhat_report", faceaCWChatReportColumn: faceaCWChatReportColumn },
  //Agent
  { agentCS_report: "agentCS_report", agentCallSummaryReport: agentCallSummaryReport },
  { agentP_report: "agentP_report", agentPerformancereport: agentPerformancereport },
  { queryHT_report: "queryHT_report", queryHandlingtime: queryHandlingtime },
  { loginL_report: "loginL_report", loginandLogoutreport: loginandLogoutreport },
  { agentS_report: "agentS_report", agentStatusreport: agentStatusreport },
  { feedback_report: "feedback_report", feedbackReport: feedbackReport },
  //CallBacksummaryreport No data

  //AiReport
  { aicq_report: "aicq_report", AIcallqualityreportColumn: AIcallqualityreportColumn },
  { aichq_report: "aichq_report", AIchatqualityreportColumn: AIchatqualityreportColumn },
  { apmra_report: "apmra_report", AgentimprovementReportColumn: AgentimprovementReportColumn },
  { apia_report: "apia_report", AgentPerImprovementandAttainmentReport: AgentPerImprovementandAttainmentReport },
  { apmrt_report: "apmrt_report", AgentPerManResultsTrendReport: AgentPerManResultsTrendReport },
  { pcrba_report: "pcrba_report", PerfComReportBotandAgent: PerfComReportBotandAgent },
  { botp_report: "botp_report", BotPerformanceReport: BotPerformanceReport },
  { bard_report: "bard_report", BotAccuracyReport: BotAccuracyReport }
];

export const filterReportColumn = (keyReport: any) => {
  let reportType: any = {};
  reportNavigation.map((value: any) => {
    let keyForNavi: any = Object.keys(value);
    if (keyForNavi[0] === keyReport) {
      reportType = {
        reportType: value[keyForNavi[0]],
        totalColumnList: value[keyForNavi[1]]
      };
    }
  })
  return reportType
}
